exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".swiper-container {\n  padding-bottom: 25px;\n}\n\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 0;\n}\n", ""]);
